import React, { useEffect, useState } from "react";
// @ts-ignore
import SideBar from './ey-ui-clone/SideBarComponent/SideBar';
import { makeStyles } from '@material-ui/core/styles';
import { SCR_APP_URLS } from "shared/consts";
import useIsLoggedIn from "./../utils/use-is-logged-in";
import store from "./../store";
import consts from "./../../../shared/consts";
import useFeature from "./../utils/subscriptionWrapper";
import { useLocalStorage } from "src/utils/use-local-storage";
import { getLibraryURL } from "src/utils/get-simulation-library-url";
import useHistory from "../use-history";
import { useTranslation } from "react-i18next";

export default function SideMenu(props) {

    const useStyles = makeStyles({
        root: {
            transition: 'none !important',
            // width : "20rem",
            // minWidth : "20rem",
            '& .MuiListItem-root:hover': {
                border: 'none'
            },
            '& .Mui-selected:hover': {
                border: 'none'
            }
        },
        content: {
            paddingTop: '0px',
            paddingLeft: '0px',
            overflow: 'hidden'
        }
    });
    const { t } = useTranslation();
    const classes = useStyles();
    const { isLoggedIn, userInfo } = useIsLoggedIn();
    const history = useHistory()
    const REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS = useFeature(consts.FEATURE_FLAG_REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS);

    const [navItems, setNavItems] = useState([]);
    const [showLoginMessage, setShowLoginMessage] = useState(true);
    const [menuOpen, setMenuOpen] = useLocalStorage('menuOpen', true);
    const [activeLink, setActiveLink] = useState('');


    useEffect(() => {
        init();
    }, [isLoggedIn, store.isReviewAllowed, store.isAdmin, store.hasEngagementManagerAccess]);

    useEffect(() => {
        checkAndSetNavItems();
    }, [store.pinnedReviews.length]);

    store.useRerenderIfChange(() => [store.isReviewAllowed, store.pinnedReviews, store.isAdmin, store.hasEngagementManagerAccess]);

    const init = async () => {
        if (isLoggedIn && store.isReviewAllowed) {
            await store.fetchPinnedReviews();
        }
        checkAndSetNavItems();
    }

    const getAndSetActiveLink = () => {
        if (location.pathname.match(SCR_APP_URLS.library)) {
            setActiveLink(t(consts.SUBSCRIPTIONS.TESTING_STUDIO));
        } else if (location.pathname.match(SCR_APP_URLS.ai)) {
            setActiveLink('AI Full Review 🪄');
        } else if (location.pathname.match(SCR_APP_URLS.automated)) {
            setActiveLink('Automatic testing');
        } else if (location.pathname.match(SCR_APP_URLS.getContractABI)) {
            setActiveLink('Get contract ABI');
        } else if (location.pathname.match(SCR_APP_URLS.verifyContractByteCode)) {
            setActiveLink('Verify contract byte-code');
        } else if (location.pathname.match(SCR_APP_URLS.aiReviewAgent)) {
            setActiveLink('🪄 AI Review Agent');
        } else if (location.pathname.match(SCR_APP_URLS.simplifier)) {
            setActiveLink('My reviews');
        } else if (location.pathname.match(SCR_APP_URLS.myReview) || location.pathname.match(SCR_APP_URLS.ciReview)) {
            setActiveLink('My reviews');
        } else if (location.pathname.match(SCR_APP_URLS.engagementManager)) {
            setActiveLink('Engagement manager');
        } else if (location.pathname.match(SCR_APP_URLS.organizationManager)) {
            setActiveLink('Organization manager');
        } else if (location.pathname.match(SCR_APP_URLS.analytics)) {
            setActiveLink('Analytics');
        } else {
            setActiveLink('Discover simulations');
        }
    }

    useEffect(() => {
        getAndSetActiveLink();
    }, []);

    const closeLoginToaster = () => () => {
        setShowLoginMessage(false);
        let NAV_ITEMS = ALL_NAV_ITEMS.filter((item) => (item.name));
        setNavItems(NAV_ITEMS);
    }

    const showLoginToaster = () => {
        setShowLoginMessage(true);
        setNavItems(ALL_NAV_ITEMS);
    }

    const handleClick = (url) => async () => {
        if (url === SCR_APP_URLS.library) {
            history.push(SCR_APP_URLS.library);
        } else {
            if (isLoggedIn) {
                if (url === SCR_APP_URLS.ai) {
                    history.push(SCR_APP_URLS.ai);
                } else if (url === SCR_APP_URLS.aiReviewAgent) {
                    history.push(SCR_APP_URLS.aiReviewAgent);
                } else if (url === SCR_APP_URLS.automated) {
                    history.push(SCR_APP_URLS.automated);
                } else if (url === SCR_APP_URLS.getContractABI) {
                    history.push(SCR_APP_URLS.getContractABI);
                } else if (url === SCR_APP_URLS.verifyContractByteCode) {
                    history.push(SCR_APP_URLS.verifyContractByteCode);
                }else if (url === SCR_APP_URLS.simplifier) {
                    history.push(SCR_APP_URLS.simplifier);
                } else if (url === SCR_APP_URLS.myReview) {
                    history.push(SCR_APP_URLS.myReview);
                } else if (url === SCR_APP_URLS.engagementManager) {
                    history.push(SCR_APP_URLS.engagementManager);
                } else if (url === SCR_APP_URLS.organizationManager) {
                    history.push(SCR_APP_URLS.organizationManager);
                } else if (url === SCR_APP_URLS.analytics) {
                    history.push(SCR_APP_URLS.analytics);
                } else {
                    let pathArr = url.split('?');
                    if (pathArr[0] == SCR_APP_URLS.library && pathArr[1]) {
                        history.push(url);
                    } else {
                        await store.newSimulation({
                            public: !REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS
                        })
                    }
                }
            } else {
                showLoginToaster();
                return;
            }
        }
        getAndSetActiveLink();
    }

    const navItemDisabled = () => {
        if (isLoggedIn) {
            return false;
        } else {
            return true;
        }
    }

    const ALL_NAV_ITEMS = [
        {
            name: t(consts.SUBSCRIPTIONS.TESTING_STUDIO),
            onClick: handleClick(SCR_APP_URLS.library),
            // icon: <Tooltip
            //         tip={'Run simulations for smart contracts on the Ethereum Mainnet in real-time.'}
            //         ><InfoOutlinedIcon style={{ fontSize: 20 }}/>
            //     </Tooltip>,
            category: "My tools",
        },      
        // {
        //     name: "AI Full Review 🪄 ",
        //     onClick: handleClick(SCR_APP_URLS.ai),
        //     // icon: <Tooltip
        //     //         tip={'Run automated tests on tokens to get a complete analysis report.'}
        //     //         ><InfoOutlinedIcon style={{ fontSize: 20 }}/>
        //     //     </Tooltip>,
        //     category: "My tools",
        //     disabled: navItemDisabled()
        // },
        {
            name: "Automatic testing",
            onClick: handleClick(SCR_APP_URLS.automated),
            // icon: <Tooltip
            //         tip={'Run automated tests on tokens to get a complete analysis report.'}
            //         ><InfoOutlinedIcon style={{ fontSize: 20 }}/>
            //     </Tooltip>,
            category: "My tools",
            disabled: navItemDisabled()
        },
        {
            name: "Get contract ABI",
            onClick: handleClick(SCR_APP_URLS.getContractABI),
            // icon: <Tooltip
            //         tip={'Run automated tests on tokens to get a complete analysis report.'}
            //         ><InfoOutlinedIcon style={{ fontSize: 20 }}/>
            //     </Tooltip>,
            category: "My tools",
            disabled: navItemDisabled()
        },
        {
            name: "Verify contract byte-code",
            onClick: handleClick(SCR_APP_URLS.verifyContractByteCode),
            // icon: <Tooltip
            //         tip={'Run automated tests on tokens to get a complete analysis report.'}
            //         ><InfoOutlinedIcon style={{ fontSize: 20 }}/>
            //     </Tooltip>,
            category: "My tools",
            disabled: navItemDisabled()
        },
        ...store.isReviewAllowed ? [{
            name: "My reviews",
            onClick: handleClick(SCR_APP_URLS.myReview),
            // icon: <Tooltip
            //         tip={'Coming up soon.'}
            //         ><InfoOutlinedIcon style={{ fontSize: 20 }}/>
            //     </Tooltip>,
            category: "My tools",
            disabled: navItemDisabled()
        }
        ] : [],
        ...store.hasEngagementManagerAccess ? [{
            name: "Engagement manager",
            onClick: handleClick(SCR_APP_URLS.engagementManager),
            // icon: <Tooltip
            //         tip={'Coming up soon.'}
            //         ><InfoOutlinedIcon style={{ fontSize: 20 }}/>
            //     </Tooltip>,
            category: "My tools",
            disabled: navItemDisabled()
        },
        ] : [],
        ...store.isAdmin && !userInfo?.auth0Subscripton ? [{
            name: "Organization manager",
            onClick: handleClick(SCR_APP_URLS.organizationManager),
            // icon: <Tooltip
            //         tip={'Coming up soon.'}
            //         ><InfoOutlinedIcon style={{ fontSize: 20 }}/>
            //     </Tooltip>,
            category: "My tools",
            disabled: navItemDisabled()
        },
        ] : [],
        ...(store.isAdmin
          //  || store.hasEngagementManagerAccess
          )? [{
            name: "Analytics",
            onClick: handleClick(SCR_APP_URLS.analytics),
            // icon: <Tooltip
            //         tip={'Coming up soon.'}
            //         ><InfoOutlinedIcon style={{ fontSize: 20 }}/>
            //     </Tooltip>,
            category: "My tools",
            disabled: navItemDisabled()
        },
        ] : []
    ];


    const checkAndSetNavItems = async () => {
        if (isLoggedIn) {
            await store.checkIsReviewAllowed(isLoggedIn['email']);
        }

        let NAV_ITEMS = [];

        if (isLoggedIn) {
            NAV_ITEMS = ALL_NAV_ITEMS.filter((item) => (item.name));
            if (store.pinnedReviews.length) {
                NAV_ITEMS = checkAndAddPinnedReviews(NAV_ITEMS);
            }
        } else {
            NAV_ITEMS = ALL_NAV_ITEMS;
        }

        setNavItems(NAV_ITEMS);
    }

    const checkAndAddPinnedReviews = (NAV_ITEMS) => {
        let pinnedMenu = store.pinnedReviews.map((review) => {
            return {
                name: review.name,
                onClick: handleClick(getLibraryURL({
                    engagement_id: review.engagement_id,
                    review_id: review._id
                })),
                category: "My tools",
            }
        });

        let indexOfMyReview = -1;

        for (let i = 0; i < NAV_ITEMS.length; i++) {
            if (NAV_ITEMS[i].name == "My reviews") {
                indexOfMyReview = i;
                break;
            }
        }

        let navArrTillMyReview = NAV_ITEMS.slice(0, indexOfMyReview + 1);
        var remainingNavArr = NAV_ITEMS.slice(indexOfMyReview + 1);
        let newNavItems = navArrTillMyReview.concat(pinnedMenu, remainingNavArr);

        return newNavItems;
    }

    const onToggleSidebar = (value) => {
        setMenuOpen(value);
    }

    return (
        <>
            <SideBar
                variant="persistent"
                className={classes.root}
                contentClassName={classes.content}
                navigationList={navItems}
                selected={activeLink}
                openDefault={menuOpen}
                onToggleSidebar={(value) => onToggleSidebar(value)}
            >
                {props.children}
            </SideBar>
        </>
    )

};